import React from 'react';
import { connect } from 'react-redux';
import DashCard from './DashCard';

import * as actions from '../../actions/calendar';
import CalendarItem from '../Calendar/CalendarItem';

/**
 * Render the vacation card.
 * Display the people currently in vacations.
 */
class CalendarSupportCard extends React.Component {
    componentDidMount() {
        this.props.fetchVacationCalendar();

        this.fetchVacationInterval = setInterval(
            function() {
                this.props.fetchVacationCalendar();
            }.bind(this),
            60 * 60 * 1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.fetchVacationCalendar);
    }

    render() {
        let style = {
            '--nbVacations':
                this.props.vacationEvents !== undefined
                    ? this.props.vacationEvents.length
                    : 0,
        };

        return (
            <DashCard
                title="Vacation"
                className="calendar-card calendar-vacations"
            >
                <div
                    className={
                        'summary-wrapper ' +
                        (this.props.vacationEvents !== undefined &&
                        this.props.vacationEvents.length > 4
                            ? 'summary-wrapper--large'
                            : '')
                    }
                    style={style}
                >
                    <div className="slide-track">
                        {this.props.vacationEvents !== undefined &&
                            this.props.vacationEvents.map((event, index) => (
                                <CalendarItem event={event} key={index} />
                            ))}

                        {this.props.vacationEvents === undefined ||
                        this.props.vacationEvents.length === 0 ? (
                            <div
                                className="calendar-card__summary"
                                style={{ backgroundColor: 'grey' }}
                            >
                                <span>No vacation Today</span>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </DashCard>
        );
    }
}

function mapStateToProps(state) {
    return {
        vacationEvents: state.calendar.vacationEvents,
        isApiLoaded: state.calendar.isApiLoaded,
    };
}

export default connect(
    mapStateToProps,
    actions
)(CalendarSupportCard);



// WEBPACK FOOTER //
// ./src/components/Cards/CalendarVacationCard.js